// extracted by mini-css-extract-plugin
export var aboveInput = "_n0-0";
export var actionButton = "_n0-5";
export var actionButtonContainer = "_n0-1";
export var actionIcon = "_n0-6";
export var aiInfoContainer = "_n0-2";
export var attachmentWrapper = "_n0-7";
export var bold = "_n0-3";
export var checkIcon = "_n0-8";
export var clickingRecipientBar = "_n0-11";
export var commentThreadSwitch = "_n0-a";
export var draftImage = "_n0-b";
export var draftImageContainer = "_n0-c";
export var draftImages = "_n0-e";
export var editButton = "_n0-g";
export var editor = "_n0-f";
export var editorContainer = "_n0-y";
export var editorErrorTooltipWrapper = "_n0-9";
export var headerDivider = "_n0-h";
export var icon = "_n0-i";
export var info = "_n0-j";
export var internal = "_n0-n";
export var internalDivider = "_n0-k";
export var internalMessage = "_n0-l";
export var messageInputCard = "_n0-m";
export var messageInputForm = "_n0-o";
export var messageInputFormInternal = "_n0-p";
export var options = "_n0-q";
export var publicMessageCustomer = "_n0-s";
export var publicMessageMerchant = "_n0-r";
export var removeImageButton = "_n0-d";
export var replyButtons = "_n0-t";
export var showSignatureButton = "_n0-u";
export var spinner = "_n0-v";
export var verticalButtonDivider = "_n0-4";
export var visibilitySelector = "_n0-w";
export var warning = "_n0-x";
export var wrappingText = "_n0-z";
export var writingInternalNoteTopBorder = "_n0-10";